export const WHITE = "white";
export const ANTHRACITE = "anthracite";
export const colorDotCodeMap = {
    [WHITE]: "00061",
    [ANTHRACITE]: "00008",
};
